module.exports = __webpack_public_path__ + "static/rappi-bg-168d3bf3d12770e00f50e31490165772.png";